import { CheckCircle2, ArrowRight } from "lucide-react";
import { packages } from "../data/homepageData";
import IntroSection from "../components/IntroSection";

export default function ServicesSection() {
  return (
    <section className="rz-section rz-section--light" id="pachete">
      <div className="rz-shell">
        <IntroSection />

        <div className="rz-grid rz-grid--services">
          {packages.map((item) => {
            const Icon = item.icon;

            return (
              <article key={item.title} className="rz-service-card">
                <div className="rz-service-card__topline">
                  <span>{item.badge}</span>
                  <div className="rz-service-card__icon">
                    <Icon size={22} />
                  </div>
                </div>

                <h3 className="info_text">{item.title}</h3>
                <p>{item.text}</p>

                <ul className="rz-hero__bullets" style={{ marginTop: 0 }}>
                  {item.features.map((feature) => (
                    <li key={feature}>
                      <CheckCircle2 size={18} />
                      {feature}
                    </li>
                  ))}
                </ul>

                <a href="#lead-form" className="rz-btn rz-btn--primary" style={{ marginTop: 20 }}>
                  {item.cta}
                  <ArrowRight size={16} />
                </a>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
